import React from 'react';
import PropTypes from 'prop-types';

import Button from '../Button';
import Icon from '../Icon';
import Spacer from '../Spacer';
import UnlockIcon from '../../svg/icons/Resy_Unlock_Icon.svg';
import { getTranslation } from '../../providers/TranslationProvider';

import './USOpenBanner.scss';

export const US_OPEN_BANNER_HEADLINE = 'Special Access with American Express';
export const US_OPEN_BANNER_TAGLINE = 'To unlock access to available reservations, log in and add your eligible American Express card to your Resy profile.';
export const US_OPEN_CARD_OFFER = 'Not a Card Member? Explore Amex Card Offers';
export const US_OPEN_BRAND_ICON = 'https://s3.amazonaws.com/resy.com/images/announcements/brand_icon.png';
export const US_OPEN_LEARN_MORE_TEXT = 'Explore Amex Card Offers';
export const US_OPEN_LEARN_MORE_LINK = 'https://www.americanexpress.com/en-us/credit-cards/offers/resy/?extlink=resy-gate&eep=46100';

// Custom banner component for us open that is displayed for users that not logged in or not eligible https://resy.atlassian.net/browse/CON-13135
const USOpenBanner = ({ isUserLoggedIn, onLogin, onAddCard }) => (
  <div className="USOpenBanner">
    <div className="USOpenBanner__content">
      <div className="USOpenBanner__Logo">
        <Icon
          component={UnlockIcon}
          iconClass="GatingMessage__Lock-anim"
          ariaLabel={getTranslation({ translationKey: 'unlocking_animation', fallback: 'Unlocking animation' })}
          height="120px"
          width="120px"
        />
      </div>
      <Spacer width="15" />

      <div className="USOpenBanner__verbiage">
        <div className="USOpenBanner__headline">
          {US_OPEN_BANNER_HEADLINE}
        </div>

        <div className="USOpenBanner__tagline">
          {US_OPEN_BANNER_TAGLINE}
        </div>
      </div>
    </div>
    <div className="USOpenBanner__ctas">
      {!isUserLoggedIn ? (
        <Button
          className="USOpenBanner__login-button"
          variant="primary"
          onClick={() => onLogin()}
          aria-label={
              getTranslation({
                translationKey: 'login',
                fallback: 'Login',
              })
            }
          fullWidth
        >
          {getTranslation({
            translationKey: 'login',
            fallback: 'Login',
          })}
        </Button>
      ) : (
        <Button
          className="USOpenBanner__login-button"
          variant="primary"
          onClick={onAddCard}
          data-test-id="us-open-login-button-banner"
          aria-label={
              getTranslation({
                translationKey: 'add_eligible_card',
                fallback: 'Add Your Eligible Card',
              })
            }
          fullWidth
        >
          {getTranslation({
            translationKey: 'add_eligible_card',
            fallback: 'Add Your Eligible Card',
          })}
        </Button>
      )}
    </div>
  </div>
);

USOpenBanner.propTypes = {
  isUserLoggedIn: PropTypes.bool.isRequired,
  onLogin: PropTypes.func.isRequired,
  onAddCard: PropTypes.func.isRequired,
};

USOpenBanner.displayName = 'USOpenBanner';

export default USOpenBanner;
